import { useSafeTranslation } from '@/hooks/use-safe-translation'
import type { CardStep } from './get-card-tab'

export interface VipCardCopy {
  tabs: { partners: string; telco: string; getCard: string }
  steps: CardStep[]
}

/**
 * The fixed copy on the page, in the viewer's language.
 *
 * It is the app's wording, carried over key for key, so a card holder reads the
 * same sentences here as in My Roshan. What the panel can change -- the hero
 * and the three benefits -- comes from the page row instead.
 */
export function useVipCardCopy(): VipCardCopy {
  const t = useSafeTranslation()

  return {
    tabs: {
      partners: t('vipCard.partners'),
      telco: t('vipCard.teleco'),
      getCard: t('vipCard.getCard'),
    },
    steps: [
      {
        title: t('vipCard.unlockTitle'),
        points: [t('vipCard.unlockLine1'), t('vipCard.unlockLine2')],
      },
      {
        title: t('vipCard.memberTitle'),
        points: [
          t('vipCard.memberBenefit1'),
          t('vipCard.memberBenefit2'),
          t('vipCard.memberBenefit3'),
          t('vipCard.memberBenefit4'),
          t('vipCard.memberBenefit5'),
        ],
      },
      {
        title: t('vipCard.qualifyTitle'),
        points: [t('vipCard.qualifyStep1'), t('vipCard.qualifyStep2'), t('vipCard.qualifyStep3')],
      },
    ],
  }
}
